import React from 'react';
import Icon from '../Icon/Icon';
import styles from './AppRequiredFieldTag.module.css';

interface AppRequiredFieldTagProps {
  message?: string;
}

const AppRequiredFieldTag: React.FC<AppRequiredFieldTagProps> = ({
  message = 'Preenchimento obrigatório',
}) => (
  <div className={styles.wrapper}>
    <span className={styles.arrow} aria-hidden="true" />
    <div className={styles.container}>
      <Icon name="info" size={20} className={styles.icon} />
      <span className={styles.text}>{message}</span>
    </div>
  </div>
);

export default AppRequiredFieldTag;
